export default __webpack_public_path__ + "static/media/cookie_01.e89e3526.webp";